import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { deleteMyFiles, myFilesFolderDelete } from '../../../../../services/CommonService';

const DeleteFilesModal = ({
  show,
  onHide,
  selectedFiles = [],
  selectedFolders = [],
  userId,
  fetchFiles,
  setSelectedFiles,
  setSelectedFolders,
  setIsSelectAll,
  toast,
  deleteType = 'myfiles',
  title = 'Confirm Delete',
  message = 'To confirm deletion, type PERMANENTLY DELETE in the text input field.',
  confirmText = 'PERMANENTLY DELETE',
  deleteButtonText = 'Delete',
  cancelButtonText = 'Cancel',
  danger = true,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!show) {
      setInputValue('');
    } else {
      // Focus the input when modal opens
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [show]);

  const handleDelete = async () => {
    setLoading(true);
    try {
      let response;
      if (deleteType === 'myfiles') {
        response = await deleteMyFiles({
          file_ids: selectedFiles,
          user_id: userId
        });
      } else {
        response = await myFilesFolderDelete({
          file_ids: selectedFiles,
          folder_ids: selectedFolders,
          user_id: userId
        });
      }
      toast.success(response?.data?.message || 'Documents deleted successfully!');
      setSelectedFiles && setSelectedFiles([]);
      setSelectedFolders && setSelectedFolders([]);
      setIsSelectAll && setIsSelectAll(false);
      fetchFiles && fetchFiles();
      setInputValue('');
      onHide();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to delete documents');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}
      <Modal show={show} onHide={onHide}>
        <Modal.Header>
          <Modal.Title className="fw-bold text-dark" style={{ fontSize: '1.5rem' }}>
            {title}
          </Modal.Title>
          <button
            type="button"
            className="bg-transparent fw-bold"
            onClick={onHide}
            disabled={loading}
            aria-label="Close"
          >
            <i className="bi bi-x-lg me-2"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="text-muted">{message}</p>
          <input
            ref={inputRef}
            type="text"
            placeholder={confirmText}
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            onPaste={e => {
              e.preventDefault();
              const pastedText = e.clipboardData.getData('text');
              setInputValue(pastedText);
            }}
            onKeyDown={e => {
              if (e.key === 'Enter' && inputValue === confirmText && !loading) {
                handleDelete();
              }
            }}
            className="form-control my-3"
            disabled={loading}
            autoComplete="off"
            spellCheck="false"
            style={{ userSelect: 'text' }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={onHide}
            className="rounded-3"
            disabled={loading}
          >
            {cancelButtonText}
          </Button>
          <Button
            variant={danger ? 'danger' : 'primary'}
            onClick={handleDelete}
            disabled={loading || inputValue !== confirmText}
            className="rounded-3"
          // style={{ backgroundColor: 'red', }}
          >
            {loading ? 'Deleting...' : deleteButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteFilesModal; 